import { createHOC } from 'vue-hoc';

import withUser from '~lib/common/hoc/withUser';
import userManagement from '~lib/common/providers/userManagement';
import fetchGroupData from '~lib/common/utils/fetchGroupData';

import BulkInvite from './BulkInvite';

const options = {
  name: 'BulkInviteContainer',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      state: {
        loading: false,
        groups: [],
        error: null,
        inviting: false,
        inviteError: null,
        inviteComplete: false,
      },
    };
  },
  async created() {
    this.state.loading = true;
    this.state.error = null;
    fetchGroupData(this.user, this.user.groups[0]).then(
      result => {
        this.state.groups = result;
      },
      error => {
        this.state.error = e;
      },
    ).then(() => {
      this.state.loading = false;
    });
  },
};

const renderWith = {
  props: {
    loading() {
      return this.state.loading;
    },
    groups() {
      return this.state.groups;
    },
    error() {
      return this.state.error;
    },
    inviting() {
      return this.state.inviting;
    },
    inviteError() {
      return this.state.inviteError;
    },
    inviteComplete() {
      return this.state.inviteComplete;
    },
  },
  listeners: {
    async submit(users, groupIds, org) {
      try {
        this.state.inviteError = null;
        this.state.inviting = true;
        const response = await userManagement.post('/invitations/invite', {
          users,
          org: {
            id: org._id,
          },
          groupMembership: groupIds,
        });
        const newUsers = response.data.map(item => item.user);
        this.$analytics.event('Org Management', 'invite', org.name);
        this.state.inviteComplete = true;
        this.$emit('submitted', newUsers);
      } catch (e) {
        console.error(e);
        this.state.inviteError = e;
      } finally {
        this.state.inviting = false;
      }
    },
  },
};

const BulkInviteContainer = createHOC(BulkInvite, options, renderWith);
export default withUser()(BulkInviteContainer);
